<template>
  <div style="float: left;">
     <v-menu bottom offset-y :id="guid" no-caret v-if="steps != undefined">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text color="primary" dark v-bind="attrs" v-on="on">Step type?</v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(s,i) in usable(steps)" :key="i" @click="setvar(s)">{{s.title}}</v-list-item>
        </v-list>
     </v-menu>
     <v-menu bottom offset-y :id="guid" no-caret v-if="inputs != undefined">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="active" text color="primary" dark v-bind="attrs" v-on="on"><apio-icon lightModeColour="white" darkModeColour="white" name="nav-arrow-down-single" /></v-btn>
          <v-btn v-else-if="!active" text color="primary" dark v-bind="attrs" v-on="on"><apio-icon lightModeColour="black" darkModeColour="black" name="nav-arrow-down-single" /></v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(s,i) in usable(inputs)" :key="i" @click="setvar(s)"><b class="mr-2">{{s.title}}</b>&ndash; {{s.tooltip}}</v-list-item>
        </v-list>
     </v-menu>
  </div>
</template>

<script>
import { uniqueId, filter } from "lodash";

export default {
  name: "AddButton",
  props: ["steps", "inputs", "mkey", "prefix", "active"],
  data() {
    return {
      guid: uniqueId()
    };
  },
  methods: {
    usable(list) {
      return filter(list, function(item) {
        return item.title != "Parser Conf" && item.title != "Sync In";
      });
    },
    setvar(e) {
      let name = e.name;
      if (name.startsWith('input_')) {
        name = name.slice(6);
      } else if (name.startsWith('step_')) {
        name = name.slice(5);
      }
      this.$root.$emit("set-module", {
        prefix: this.prefix,
        mkey: this.mkey,
        module: name,
        settings: e,
      });
    }
  }
};
</script>
